import React, { useState, useEffect } from 'react';
import { FormControl } from 'baseui/form-control';
import { Input } from 'baseui/input';
import { Button } from 'baseui/button';
import useExternalLogin from './useExternalLogin';
import useStyles from './useStyles';

const ExternalLogin: React.FC<{}> = () => {
	const { handleEmailSubmit, handleOtpSubmit } = useExternalLogin();
	const classes = useStyles();
	const [email, setEmail] = useState('');
	const [otp, setOtp] = useState(undefined);
	const [counter, setCounter] = useState(0);

	// eslint-disable-next-line consistent-return
	useEffect(() => {
		if (counter > 0) {
			const timer = setInterval(() => setCounter(counter - 1), 1000);
			return () => clearInterval(timer);
		}
	}, [counter]);

	const onChangeEmail = (event: any) => {
		setEmail(event?.target?.value);
	};

	const onChangeOtp = (event: any) => {
		setOtp(event?.target?.value);
	};

	const formControlOverrides = {
		ControlContainer: {
			style: () => classes.formControlContainer
		},
		Label: {
			style: () => classes.formControlLabel
		}
	};

	const handleEmailOnSubmit = async (event: any) => {
		event.preventDefault();
		const data = await handleEmailSubmit(email);
		if (data.success) {
			setCounter(data.validity);
		}
	};

	const handleOtpOnSubmit = async (event: any) => {
		event.preventDefault();
		await handleOtpSubmit(email, otp);
	};

	const showOtpBtn = () => {
		return counter === 0 ? (
			<Button type='submit' size='mini'>
				Send OTP
			</Button>
		) : (
			`Resend OTP in ${counter}`
		);
	};

	return (
		<>
			<form onSubmit={handleEmailOnSubmit}>
				<FormControl label='EMAIL ID' overrides={formControlOverrides}>
					<Input id='email-input-id' value={email} onChange={onChangeEmail} type='email' required />
				</FormControl>
				<div className={classes.otpButton}>{showOtpBtn()}</div>
			</form>
			<form onSubmit={handleOtpOnSubmit}>
				<FormControl label='OTP' overrides={formControlOverrides}>
					<Input id='otp-input-id' value={otp} onChange={onChangeOtp} required />
				</FormControl>
				<div className={classes.signInButton}>
					<Button type='submit'>Sign In</Button>
				</div>
			</form>
		</>
	);
};

export default ExternalLogin;
